export const DY_ITEMS_COUNT = 8;
